import { useCallback, useEffect, useState } from 'react';
import _debounce from 'lodash/debounce';

import Input from 'components/_parts/atoms/input';
import PopUp from 'components/_parts/atoms/popUp/compentencies/index';

function Index(props) {
  const datas = props?.datas;
  const [hideShowExport, setHideShowExport] = useState(false);
  const [dataFilter, setDataFilter] = useState([]);

  const handleShows = () => {
    setHideShowExport(!hideShowExport);
  };

  const handleSearch = (e) => {
    const keyword = e.target.value?.toLowerCase();
    if (keyword !== '') {
      const filter = datas?.filter((val) => val.label?.toLowerCase()?.includes(keyword));
      if (filter.length === 0) {
        setDataFilter([{ id: 1, label: 'Data Tidak Ditemukan' }]);
      } else {
        setDataFilter(filter);
      }
    } else {
      setDataFilter(datas);
      props?.setChoose(props?.competencyPart, '');
    }
  };

  useEffect(() => {
    if (
      props.setValueType !== undefined
      && props.name === 'filter_competency'
    ) {
      props?.setValueType(props?.choose?.label);
    } else if (
      props.setValueLevel !== undefined
      && props.name === 'filter_level'
    ) {
      props?.setValueLevel(props?.choose?.label);
      props?.setIdCompetencies(props?.choose?.value);
      props?.setLevelDesc(props?.choose);
    } else if (props.setInputValue !== undefined) {
      props?.setInputValue(props?.choose?.label);
    } else if (
      props.setValueComp !== undefined
      && props.name === 'filterComp'
    ) {
      props?.setValueComp(props?.choose?.label);
    }

    if (props.setCC !== undefined) {
      const Comp = props?.choose?.data?.[0]?.competency_group;
      const CC = props?.choose?.data?.[0]?.competency_type;
      const CL = props?.choose?.data?.[0]?.competency_level;
      const LD = props?.choose?.data?.[0];
      const ID = props?.choose?.data?.[0]?.competency_detail_id;
      if ((props?.type === 1 || props?.type === 2) && props?.choose !== '') {
        props?.setCC?.setCC(props?.choose?.value);
        props?.setCC?.setTypeCC(CC);
        props?.setCC?.setTypeComp(Comp);
        props?.setCC?.setValueType(CC);
        props?.setCC?.setValueLevel(CL);
        props?.setCC?.setLevelDesc(LD);
        props?.setCC?.setIdCompetencies(ID);
      } else if ((props?.type !== 1 || props?.type !== 2)) {
        props?.setCC(props?.choose?.value);
      }
    } else if (props.setTypeComp !== undefined) {
      // props?.setTypeComp(props?.choose?.label);
      props?.setTypeComp(props?.choose?.value);
    } else if (props.setTypeCC !== undefined) {
      props?.setTypeCC(props?.choose?.value);
    }

    setDataFilter([]);
  }, [props?.choose]);

  const debounceHandler = useCallback(_debounce(handleSearch, 300), [datas]);

  return (
    <div
      className={`dropdown_container ${props?.className}`}
      style={{ width: '500px', ...props?.style }}
      onClick={handleShows}
      {...props}
    >
      <Input
        id="input-search-custom"
        type="search"
        name={props?.name}
        placeholder={props?.placeholder}
        value={
          props?.inputValue
            ? props?.inputValue
            : props?.valueType
              ? props?.valueType
              : props?.valueLevel
                ? props?.valueLevel
                : props?.valueComp
                  ? props?.valueComp
                  : ''
        }
        onChange={(e) => {
          debounceHandler(e);
          props?.valueType !== undefined
            ? props?.setValueType(e?.target?.value)
            : props?.valueLevel !== undefined
              ? props?.setValueLevel(e?.target?.value)
              : props?.valueComp !== undefined
              ? props?.setValueComp(e?.target?.value)
              : props?.setInputValue(e?.target?.value);
        }}
        disable={props?.disable}
      />

      <PopUp
        isHide={hideShowExport}
        setIsHide={setHideShowExport}
        type="search"
        datas={dataFilter.length !== 0 ? dataFilter : datas}
        className={props.styleOption}
        competencyPart={props?.competencyPart}
        setChoose={props?.setChoose}
      />
    </div>
  );
}

export default Index;
